<wj-flex-grid #fxGrid (initialized)="onFxGridInitialized(fxGrid)"
              [showSelectedHeaders]="Wijmo.HeadersVisibility.All"
              [showMarquee]="true" width="100%" height="100%"
              [allowResizing]="Wijmo.AllowResizing.Columns" [autoRowHeights]="false" [quickAutoSize]="false"
              [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange" [isReadOnly]="true"
              [autoGenerateColumns]="false"
>
    <wj-flex-grid-filter #gridFilter></wj-flex-grid-filter>
</wj-flex-grid>
<div class="layout-hbox" style="align-items: center; justify-content: flex-end; grid-gap: 10px;">
    <wj-flex-grid-search style="flex-grow: 1"
                         placeholder="Search key(s)"
                         [grid]="fxGrid">
    </wj-flex-grid-search>
    <div style="white-space: nowrap">Showing {{visibleRowCount()}} items</div>
</div>

